import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiDebugService {

  errors: any[] = [];
  
  addError(error: any) {
    this.errors.push({
      id: this.errors.length + 1,
      url: error.url,
      status: error.status,
      message: error.message,
      body: error.error
    });
  }

  getErrors() {
    return this.errors;
  }
  
  clear() {
    this.errors = [];
  }
}
